module.exports = __webpack_public_path__ + "img/avatar-woman.756434d7.svg";